<template>
  <div
    v-if="cookieConsent !== 'accepted'"
    class="fixed right-0 mx-3 max-w-60 bottom-3 z-50 rounded-lg border bg-white p-4 text-xs font-medium shadow-lg md:left-auto md:p-5 md:max-w-80 md:text-sm"
  >
    <div class="flex items-center space-x-3">
      <Icon
        icon="cookie-bite"
        prefix="far"
        class="text-2xl text-[#ea9654] md:text-[1.75rem] leading-[2.125rem]"
      />
      <p>
        {{ $t("cookies_description") }} <NuxtLink to="/cookies">{{ $t("learn_more") }}</NuxtLink>
      </p>
    </div>
    <Button
      full-width
      size="xs"
      class="mt-3 md:mt-4"
      :ui="{ base: 'md:px-4 md:py-2.5' }"
      @click="acceptCookies"
    >
      {{ $t("accept") }}
    </Button>
  </div>
</template>

<script setup lang="ts">
import { useCookie } from '#app'

const cookieConsent = useCookie('cookie-consent', {
  domain: '.inspires.to',
  maxAge: 60 * 60 * 24 * 365,
  secure: true,
  sameSite: 'lax'
})

const acceptCookies = () => {
  cookieConsent.value = 'accepted'
}
</script>
